module.exports = __webpack_public_path__ + "static/request-screens-b9cf161dfcac4570eb88f7ae94a4b51b.jpg";